import { Component, OnInit } from '@angular/core';
import { MatCardModule } from '@angular/material/card';
import { RouterLink } from '@angular/router';
import { CustomizerSettingsService } from '../../customizer-settings/customizer-settings.service';
import { SampleService } from '../../services/sample-service/sample.service';

@Component({
    selector: 'app-total-projects',
    standalone: true,
    imports: [MatCardModule, RouterLink],
    templateUrl: './total-projects.component.html',
    styleUrl: './total-projects.component.scss'
})
export class TotalProjectsComponent implements OnInit {

    // isToggled
    isToggled = false;
    totalSamples : number = 0


    constructor(
        public themeService: CustomizerSettingsService,
        public sampleService:SampleService
    ) {
        this.themeService.isToggled$.subscribe(isToggled => {
            this.isToggled = isToggled;
        });
    }

    ngOnInit(){
        this.totalSample()
    }

    // Dark Mode
    toggleTheme() {
        this.themeService.toggleTheme();
    }

    totalSample(){
        this.sampleService.total().subscribe({
            next: (data) => {
                this.totalSamples = data
                },
        })
    }

}